import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  accountDetail(params) { //我的账户详情
    const url =  baseURL + '/tbUser/getDetail';
    return axios.post(url, qs.stringify(params));
  },
  accountUpdate(params) { //修改账户详情
    const url =  baseURL + '/tbUser/modify';
    return axios.post(url, qs.stringify(params));
  },
  
  
}


// WEBPACK FOOTER //
// ./src/api/account.js